import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';

import { Observable, switchMap } from 'rxjs';

import { BaseColumnComponent } from '../../../../record/services/base-column-component';
import { DownloadRow, NaamCellData } from '../../../entities/download-row.entity';

@Component({
    standalone: false,
    selector: 'digihaven-download-naam-cell',
    templateUrl: './download-naam-cell.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DownloadNaamCellComponent extends BaseColumnComponent<DownloadRow> {
    readonly naam$: Observable<NaamCellData>;

    constructor(cd: ChangeDetectorRef) {
        super(cd);

        this.naam$ = this.data$.pipe(switchMap(row => row.naam$));
    }
}
